unit View.Compras.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UConstantes, UUtils, System.StrUtils, XData.Web.Client,
  UFrameDataBase, Vcl.Forms, UHelperServer, UPersonalizacao_Tabela,
  UPersonalizacao_Tabela.Interfaces, System.DateUtils;

type
  TFViewComprasList = class(TForm)
    ComprasDataset: TXDataWebDataSet;
    ComprasDatasetid: TIntegerField;
    ComprasDatasetcfop: TStringField;
    ComprasDatasetmodelo: TStringField;
    ComprasDatasetserie: TStringField;
    ComprasDatasetemissao: TDateTimeField;
    ComprasDatasetentrada: TDateTimeField;
    ComprasDatasetvalor_total: TFloatField;
    ComprasDatasetcodigo_interno: TIntegerField;
    ComprasDatasetexcluido: TBooleanField;
    ComprasDatasetinclusao: TDateTimeField;
    ComprasDatasetalteracao: TDateTimeField;
    ComprasDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    ComprasDatasetcompra_xml_s3: TMemoField;
    ComprasDatasetanexo_sincronizado: TIntegerField;
    ComprasDatasetfornecedorrazao_social_nome: TXDataWebDatasetField;
    btnExportarExcel: TButton;
    btnPesquisarFornecedor: TButton;
    btnPesquisarCompras: TButton;
    cbbComprasNfe: TComboBox;
    cbxComprasExcluidas: TCheckBox;
    edtFornecedorNome: TEdit;
    edtDataFinal: TDateTimePicker;
    edtDataInicial: TDateTimePicker;
    edtComprasCfop: TEdit;
    XDataWebClient: TXDataWebClient;
    frmBanco: TfrmDataBase;
    cbbComprasXml: TComboBox;
    procedure WebFormCreate(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure btnPesquisarComprasClick(Sender: TObject);
    procedure btnPesquisarFornecedorClick(Sender: TObject);
    procedure XDataWebClientError(Error: TXDataClientError);
    procedure XDataWebClientLoad(Response: TXDataClientResponse);
    procedure btnExportarExcelClick(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;

    procedure ConfigurarData;
    function GetFiltro : string;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewComprasList: TFViewComprasList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewComprasList }

procedure TFViewComprasList.btnExportarExcelClick(Sender: TObject);
begin
  TUtils.ExportarDadosExcel(ComprasDataset, WebDBTableControl1,
    FGridPlugin.FDatasetPlugin.FDataset.QueryString, FGridPlugin.FQuantidadeRegistrosBusca);
end;

procedure TFViewComprasList.btnPesquisarComprasClick(Sender: TObject);
var
  lDataInvalida : string;
begin
  lDataInvalida := THelperServer.ValidarDatasMovimentos(edtDataInicial.Text, edtDataFinal.Text);

  if not lDataInvalida.IsEmpty then
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, lDataInvalida);
    Exit;
  end;

  FGridPlugin.FDatasetPlugin.FFilterPadrao := GetFiltro;
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewComprasList.btnPesquisarFornecedorClick(Sender: TObject);
begin
  THelperServer.ChamarConsulta('Fornecedores', 'fornecedores', edtFornecedorNome);
end;

procedure TFViewComprasList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

procedure TFViewComprasList.ConfigurarData;
begin
  edtDataFinal.Max := Date;
  edtDataInicial.Min := IncDay(Date, -365);
  edtDataInicial.Date := IncDay(Date, -365);
  edtDataFinal.Date := Date;
end;

class function TFViewComprasList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewComprasList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewComprasList, AElementID, Result, @AfterCreate);
end;

procedure TFViewComprasList.edSearchKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
    FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewComprasList.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

function TFViewComprasList.GetFiltro: string;
var
  lListaFiltro : TStringList;
  lFiltroBanco : string;
begin
  Result := EmptyStr;
  lListaFiltro := TStringList.Create;

  try
    if not cbxComprasExcluidas.Checked then
      lListaFiltro.Add('(excluido eq false)');

    if edtFornecedorNome.Tag <> 0 then
      lListaFiltro.Add('(fornecedores_id eq '+edtFornecedorNome.Tag.ToString+')');

    if not Trim(edtComprasCfop.Text).IsEmpty then
      lListaFiltro.Add('(cfop eq '+QuotedStr(edtComprasCfop.Text)+')');

    if ((edtDataInicial.Text <> '') and (edtDataFinal.Text <> '')) then
    begin
      lListaFiltro.Add('((emissao ge '+edtDataInicial.Text+') and ' +
        '(emissao le '+edtDataFinal.Text+'))');
    end;

    lFiltroBanco := frmBanco.GetFilterDataBase;

    if not lFiltroBanco.IsEmpty then
      lListaFiltro.Add('(data_base_id eq '+lFiltroBanco+')');

    case cbbComprasNfe.ItemIndex of
      1: lListaFiltro.Add('(chave_nfe ne null)');
      2: lListaFiltro.Add('(chave_nfe eq null)');
    end;

    case cbbComprasXml.ItemIndex of
      1: lListaFiltro.Add('((anexo_sincronizado eq 1) and (compra_xml_s3 ne null))');
      2: lListaFiltro.Add('((compra_xml_s3 eq null) or (anexo_sincronizado eq 0))');
    end;

    if lListaFiltro.Count > 0 then
      Result := string.Join(' and ', lListaFiltro.ToStringArray);
  finally
    if Assigned(lListaFiltro) then
      FreeAndNil(lListaFiltro)
  end;
end;

procedure TFViewComprasList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewComprasList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;
  RecordCompraId : Integer;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

  procedure BaixarArquivoButtonClick(Sender: TObject);
  var
    lBotaoSelecionado : TButton;
    lJson : TJSObject;
    lBotaoNome : string;
  begin
    TUtils.ChamarDivLoading;

    lBotaoSelecionado := TButton(Sender);
    lBotaoNome := lBotaoSelecionado.Name;

    lJson := TJSObject.New;

    if lBotaoNome = 'rbtBaixarXml'  then
      lJson['tipo'] := 'xml'
    else if lBotaoNome = 'rbtBaixarDanfe' then
      lJson['tipo'] := 'danfe';

    lJson['codigo'] := lBotaoSelecionado.Tag;
    lJson['tabela'] := 'compras';

    XDataWebClient.RawInvoke('IService.BaixarArquivo', [lJson]);
  end;

var
  Button: TButton;
  lHabilitarDanfeXml : Boolean;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ações' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      ComprasDataset.Connection.Model.DefaultSchema.FindEntityType(ComprasDataset.EntitySetName),
      ComprasDataset.CurrentData
    );

    RecordCompraId := ComprasDataset.FieldByName('id').AsInteger;

    lHabilitarDanfeXml := not ComprasDataset.FieldByName('compra_xml_s3').AsString.IsEmpty and
      (ComprasDataset.FieldByName('anexo_sincronizado').AsString = '1');

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-eye"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_compra');

    Button := TButton.Create(nil);
    Button.Name := 'rbtBaixarXml';
    Button.Tag := RecordCompraId;
    Button.Caption := '<i class="fas fa-file-code"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_baixar_xml');

    if lHabilitarDanfeXml then
    begin
      Button.OnClick := @BaixarArquivoButtonClick;
      Button.ElementClassName := 'btn btn-link btn-secondary btn-lg';
      Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
      Button.ElementHandle.setAttribute('title', 'Baixar XML');
    end
    else
    begin
      Button.ElementClassName := 'btn btn-link text-muted btn-lg';
      Button.ElementHandle.style.setProperty('cursor', 'not-allowed');
    end;

    Button := TButton.Create(nil);
    Button.Name := 'rbtBaixarDanfe';
    Button.Tag := RecordCompraId;
    Button.Caption := '<i class="fas fa-file-pdf"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_baixar_danfe');

    if lHabilitarDanfeXml then
    begin
      Button.OnClick := @BaixarArquivoButtonClick;
      Button.ElementClassName := 'btn btn-link btn-danger btn-lg';
      Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
      Button.ElementHandle.setAttribute('title', 'Baixar Danfe');
    end
    else
    begin
      Button.ElementClassName := 'btn btn-link text-muted btn-lg';
      Button.ElementHandle.style.setProperty('cursor', 'not-allowed');
    end;
  end;
end;

procedure TFViewComprasList.WebDBTableControl1GetCellClass(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['fornecedor.razao_social_nome', 'valor_total']) of
      0: AClassName := 'text-start';
      1: AClassName := 'text-end'
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewComprasList.WebDBTableControl1GetCellData(Sender: TObject; ACol,
  ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['excluido']) of
     0:
      begin
        if AValue = 'True' then
          AValue := '<i class="fas fa-check text-success"><i>'
        else if AValue = 'False' then
          AValue := '<i class="fas fa-times text-danger"><i>';
      end;
    end;
  end;
end;

procedure TFViewComprasList.WebFormCreate(Sender: TObject);
begin
  ConfigurarData;
  frmBanco.ConfigurarDataBase;

  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('compras', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(WebDBTableControl1, ComprasDataset, lcPaginator,
    lbPaginationInfo);

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'codigo_interno desc';
  FGridPlugin.FDatasetPlugin.FFilterPadrao := GetFiltro;
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewComprasList.XDataWebClientError(Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Error.ErrorMessage);
end;

procedure TFViewComprasList.XDataWebClientLoad(Response: TXDataClientResponse);
var
  lJSONObject: TJSObject;
begin
  lJSONObject := Response.ResultAsObject;
  THelperServer.BaixarAnexo(string(lJSONObject['arquivo_base64']), string(lJSONObject['arquivo_nome']));
end;

procedure TFViewComprasList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.compras.list.pagination.info');
  WebDBTableControl1 := TDBTableControl.Create('view.compras.list.table');
  cbPageSize := TComboBox.Create('view.compras.list.cbPageSize');
  edSearch := TEdit.Create('view.compras.list.search');
  lcPaginator := TListControl.Create('view.compras.list.pagination');
  btnExportarExcel := TButton.Create('btnExportarExcel');
  btnPesquisarFornecedor := TButton.Create('btnPesquisarFornecedor');
  btnPesquisarCompras := TButton.Create('btnPesquisarCompras');
  cbbComprasNfe := TComboBox.Create('cbbComprasNfe');
  cbxComprasExcluidas := TCheckBox.Create('cbxComprasExcluidas');
  edtFornecedorNome := TEdit.Create('edtFornecedorNome');
  edtDataFinal := TDateTimePicker.Create('edtDataFinal');
  edtDataInicial := TDateTimePicker.Create('edtDataInicial');
  edtComprasCfop := TEdit.Create('edtComprasCfop');
  frmBanco := TfrmDataBase.Create(Self);
  cbbComprasXml := TComboBox.Create('cbbComprasXml');
  ComprasDataset := TXDataWebDataSet.Create(Self);
  ComprasDatasetcodigo_interno := TIntegerField.Create(Self);
  ComprasDatasetfornecedorrazao_social_nome := TXDataWebDatasetField.Create(Self);
  ComprasDatasetemissao := TDateTimeField.Create(Self);
  ComprasDatasetentrada := TDateTimeField.Create(Self);
  ComprasDatasetvalor_total := TFloatField.Create(Self);
  ComprasDatasetcfop := TStringField.Create(Self);
  ComprasDatasetmodelo := TStringField.Create(Self);
  ComprasDatasetserie := TStringField.Create(Self);
  ComprasDatasetexcluido := TBooleanField.Create(Self);
  ComprasDatasetinclusao := TDateTimeField.Create(Self);
  ComprasDatasetalteracao := TDateTimeField.Create(Self);
  ComprasDatasetexclusao := TDateTimeField.Create(Self);
  ComprasDatasetid := TIntegerField.Create(Self);
  ComprasDatasetcompra_xml_s3 := TMemoField.Create(Self);
  ComprasDatasetanexo_sincronizado := TIntegerField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);
  XDataWebClient := TXDataWebClient.Create(Self);

  frmBanco.LoadFromForm;
  lbPaginationInfo.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  btnExportarExcel.BeforeLoadDFMValues;
  btnPesquisarFornecedor.BeforeLoadDFMValues;
  btnPesquisarCompras.BeforeLoadDFMValues;
  cbbComprasNfe.BeforeLoadDFMValues;
  cbxComprasExcluidas.BeforeLoadDFMValues;
  edtFornecedorNome.BeforeLoadDFMValues;
  edtDataFinal.BeforeLoadDFMValues;
  edtDataInicial.BeforeLoadDFMValues;
  edtComprasCfop.BeforeLoadDFMValues;
  frmBanco.BeforeLoadDFMValues;
  frmBanco.cbbDataBasePesquisa.BeforeLoadDFMValues;
  cbbComprasXml.BeforeLoadDFMValues;
  ComprasDataset.BeforeLoadDFMValues;
  ComprasDatasetcodigo_interno.BeforeLoadDFMValues;
  ComprasDatasetfornecedorrazao_social_nome.BeforeLoadDFMValues;
  ComprasDatasetemissao.BeforeLoadDFMValues;
  ComprasDatasetentrada.BeforeLoadDFMValues;
  ComprasDatasetvalor_total.BeforeLoadDFMValues;
  ComprasDatasetcfop.BeforeLoadDFMValues;
  ComprasDatasetmodelo.BeforeLoadDFMValues;
  ComprasDatasetserie.BeforeLoadDFMValues;
  ComprasDatasetexcluido.BeforeLoadDFMValues;
  ComprasDatasetinclusao.BeforeLoadDFMValues;
  ComprasDatasetalteracao.BeforeLoadDFMValues;
  ComprasDatasetexclusao.BeforeLoadDFMValues;
  ComprasDatasetid.BeforeLoadDFMValues;
  ComprasDatasetcompra_xml_s3.BeforeLoadDFMValues;
  ComprasDatasetanexo_sincronizado.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  XDataWebClient.BeforeLoadDFMValues;
  try
    Name := 'FViewComprasList';
    Width := 719;
    Height := 343;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 312;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 30;
    WebDBTableControl1.Width := 329;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#245'es';
      Width := 150;
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'C'#243'd. Retaguarda';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'fornecedor.razao_social_nome';
      Title := 'Fornecedor';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'emissao';
      Title := 'Emiss'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'entrada';
      Title := 'Entrada';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_total';
      Title := 'Valor';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cfop';
      Title := 'cfop';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'modelo';
      Title := 'modelo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'serie';
      Title := 'S'#233'rie';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'Exclu'#237'do';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'Exclus'#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 3;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 216;
    edSearch.Top := 3;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 301;
    lcPaginator.Width := 97;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    btnExportarExcel.SetParentComponent(Self);
    btnExportarExcel.Name := 'btnExportarExcel';
    btnExportarExcel.Left := 352;
    btnExportarExcel.Top := 11;
    btnExportarExcel.Width := 96;
    btnExportarExcel.Height := 25;
    btnExportarExcel.Caption := 'Exportar Excel';
    btnExportarExcel.ChildOrder := 11;
    btnExportarExcel.HeightPercent := 100.000000000000000000;
    btnExportarExcel.WidthPercent := 100.000000000000000000;
    SetEvent(btnExportarExcel, Self, 'OnClick', 'btnExportarExcelClick');
    btnPesquisarFornecedor.SetParentComponent(Self);
    btnPesquisarFornecedor.Name := 'btnPesquisarFornecedor';
    btnPesquisarFornecedor.Left := 615;
    btnPesquisarFornecedor.Top := 42;
    btnPesquisarFornecedor.Width := 30;
    btnPesquisarFornecedor.Height := 22;
    btnPesquisarFornecedor.ChildOrder := 22;
    btnPesquisarFornecedor.HeightPercent := 100.000000000000000000;
    btnPesquisarFornecedor.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarFornecedor, Self, 'OnClick', 'btnPesquisarFornecedorClick');
    btnPesquisarCompras.SetParentComponent(Self);
    btnPesquisarCompras.Name := 'btnPesquisarCompras';
    btnPesquisarCompras.Left := 352;
    btnPesquisarCompras.Top := 212;
    btnPesquisarCompras.Width := 96;
    btnPesquisarCompras.Height := 25;
    btnPesquisarCompras.Caption := 'Pesquisar';
    btnPesquisarCompras.ChildOrder := 11;
    btnPesquisarCompras.HeightPercent := 100.000000000000000000;
    btnPesquisarCompras.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarCompras, Self, 'OnClick', 'btnPesquisarComprasClick');
    cbbComprasNfe.SetParentComponent(Self);
    cbbComprasNfe.Name := 'cbbComprasNfe';
    cbbComprasNfe.Left := 352;
    cbbComprasNfe.Top := 101;
    cbbComprasNfe.Width := 120;
    cbbComprasNfe.Height := 21;
    cbbComprasNfe.HeightPercent := 100.000000000000000000;
    cbbComprasNfe.Text := 'TODOS';
    cbbComprasNfe.WidthPercent := 100.000000000000000000;
    cbbComprasNfe.ItemIndex := 0;
    cbbComprasNfe.Items.BeginUpdate;
    try
      cbbComprasNfe.Items.Clear;
      cbbComprasNfe.Items.Add('TODOS');
      cbbComprasNfe.Items.Add('SIM');
      cbbComprasNfe.Items.Add('N'#195'O');
    finally
      cbbComprasNfe.Items.EndUpdate;
    end;
    cbxComprasExcluidas.SetParentComponent(Self);
    cbxComprasExcluidas.Name := 'cbxComprasExcluidas';
    cbxComprasExcluidas.Left := 494;
    cbxComprasExcluidas.Top := 70;
    cbxComprasExcluidas.Width := 151;
    cbxComprasExcluidas.Height := 22;
    cbxComprasExcluidas.Caption := 'Exibir Exclu'#237'dos?';
    cbxComprasExcluidas.ChildOrder := 9;
    cbxComprasExcluidas.HeightPercent := 100.000000000000000000;
    cbxComprasExcluidas.WidthPercent := 100.000000000000000000;
    edtFornecedorNome.SetParentComponent(Self);
    edtFornecedorNome.Name := 'edtFornecedorNome';
    edtFornecedorNome.Left := 494;
    edtFornecedorNome.Top := 42;
    edtFornecedorNome.Width := 120;
    edtFornecedorNome.Height := 22;
    edtFornecedorNome.ChildOrder := 21;
    edtFornecedorNome.Enabled := False;
    edtFornecedorNome.HeightPercent := 100.000000000000000000;
    edtFornecedorNome.WidthPercent := 100.000000000000000000;
    edtDataFinal.SetParentComponent(Self);
    edtDataFinal.Name := 'edtDataFinal';
    edtDataFinal.Left := 352;
    edtDataFinal.Top := 70;
    edtDataFinal.Width := 120;
    edtDataFinal.Height := 22;
    edtDataFinal.BorderStyle := bsSingle;
    edtDataFinal.ChildOrder := 109;
    edtDataFinal.Color := clWhite;
    edtDataFinal.Date := 45980.718362395830000000;
    edtDataFinal.Role := '';
    edtDataFinal.Text := '';
    edtDataInicial.SetParentComponent(Self);
    edtDataInicial.Name := 'edtDataInicial';
    edtDataInicial.Left := 352;
    edtDataInicial.Top := 42;
    edtDataInicial.Width := 120;
    edtDataInicial.Height := 22;
    edtDataInicial.BorderStyle := bsSingle;
    edtDataInicial.ChildOrder := 109;
    edtDataInicial.Color := clWhite;
    edtDataInicial.Date := 45980.718362395830000000;
    edtDataInicial.Role := '';
    edtDataInicial.Text := '';
    edtComprasCfop.SetParentComponent(Self);
    edtComprasCfop.Name := 'edtComprasCfop';
    edtComprasCfop.Left := 494;
    edtComprasCfop.Top := 98;
    edtComprasCfop.Width := 151;
    edtComprasCfop.Height := 22;
    edtComprasCfop.ChildOrder := 10;
    edtComprasCfop.HeightPercent := 100.000000000000000000;
    edtComprasCfop.MaxLength := 4;
    edtComprasCfop.WidthPercent := 100.000000000000000000;
    frmBanco.SetParentComponent(Self);
    frmBanco.Name := 'frmBanco';
    frmBanco.Left := 494;
    frmBanco.Top := 126;
    frmBanco.Width := 215;
    frmBanco.Height := 61;
    frmBanco.TabOrder := 13;
    frmBanco.Visible := False;
    frmBanco.cbbDataBasePesquisa.Height := 21;
    cbbComprasXml.SetParentComponent(Self);
    cbbComprasXml.Name := 'cbbComprasXml';
    cbbComprasXml.Left := 352;
    cbbComprasXml.Top := 132;
    cbbComprasXml.Width := 120;
    cbbComprasXml.Height := 21;
    cbbComprasXml.HeightPercent := 100.000000000000000000;
    cbbComprasXml.Text := 'TODOS';
    cbbComprasXml.WidthPercent := 100.000000000000000000;
    cbbComprasXml.ItemIndex := 0;
    cbbComprasXml.Items.BeginUpdate;
    try
      cbbComprasXml.Items.Clear;
      cbbComprasXml.Items.Add('TODOS');
      cbbComprasXml.Items.Add('SIM');
      cbbComprasXml.Items.Add('N'#195'O');
    finally
      cbbComprasXml.Items.EndUpdate;
    end;
    ComprasDataset.SetParentComponent(Self);
    ComprasDataset.Name := 'ComprasDataset';
    ComprasDataset.EntitySetName := 'Compras';
    ComprasDataset.Connection := DMConnection.ApiConnection;
    ComprasDataset.Left := 72;
    ComprasDataset.Top := 80;
    ComprasDatasetcodigo_interno.SetParentComponent(ComprasDataset);
    ComprasDatasetcodigo_interno.Name := 'ComprasDatasetcodigo_interno';
    ComprasDatasetcodigo_interno.FieldName := 'codigo_interno';
    ComprasDatasetcodigo_interno.Required := True;
    ComprasDatasetfornecedorrazao_social_nome.SetParentComponent(ComprasDataset);
    ComprasDatasetfornecedorrazao_social_nome.Name := 'ComprasDatasetfornecedorrazao_social_nome';
    ComprasDatasetfornecedorrazao_social_nome.FieldName := 'fornecedor.razao_social_nome';
    ComprasDatasetemissao.SetParentComponent(ComprasDataset);
    ComprasDatasetemissao.Name := 'ComprasDatasetemissao';
    ComprasDatasetemissao.FieldName := 'emissao';
    ComprasDatasetemissao.DisplayFormat := 'dd/mm/yy';
    ComprasDatasetentrada.SetParentComponent(ComprasDataset);
    ComprasDatasetentrada.Name := 'ComprasDatasetentrada';
    ComprasDatasetentrada.FieldName := 'entrada';
    ComprasDatasetentrada.DisplayFormat := 'dd/mm/yy';
    ComprasDatasetvalor_total.SetParentComponent(ComprasDataset);
    ComprasDatasetvalor_total.Name := 'ComprasDatasetvalor_total';
    ComprasDatasetvalor_total.FieldName := 'valor_total';
    ComprasDatasetvalor_total.Required := True;
    ComprasDatasetvalor_total.DisplayFormat := '#,##0.00';
    ComprasDatasetcfop.SetParentComponent(ComprasDataset);
    ComprasDatasetcfop.Name := 'ComprasDatasetcfop';
    ComprasDatasetcfop.FieldName := 'cfop';
    ComprasDatasetcfop.Required := True;
    ComprasDatasetcfop.Size := 255;
    ComprasDatasetmodelo.SetParentComponent(ComprasDataset);
    ComprasDatasetmodelo.Name := 'ComprasDatasetmodelo';
    ComprasDatasetmodelo.FieldName := 'modelo';
    ComprasDatasetmodelo.Size := 255;
    ComprasDatasetserie.SetParentComponent(ComprasDataset);
    ComprasDatasetserie.Name := 'ComprasDatasetserie';
    ComprasDatasetserie.FieldName := 'serie';
    ComprasDatasetserie.Size := 255;
    ComprasDatasetexcluido.SetParentComponent(ComprasDataset);
    ComprasDatasetexcluido.Name := 'ComprasDatasetexcluido';
    ComprasDatasetexcluido.FieldName := 'excluido';
    ComprasDatasetinclusao.SetParentComponent(ComprasDataset);
    ComprasDatasetinclusao.Name := 'ComprasDatasetinclusao';
    ComprasDatasetinclusao.FieldName := 'inclusao';
    ComprasDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    ComprasDatasetalteracao.SetParentComponent(ComprasDataset);
    ComprasDatasetalteracao.Name := 'ComprasDatasetalteracao';
    ComprasDatasetalteracao.FieldName := 'alteracao';
    ComprasDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    ComprasDatasetexclusao.SetParentComponent(ComprasDataset);
    ComprasDatasetexclusao.Name := 'ComprasDatasetexclusao';
    ComprasDatasetexclusao.FieldName := 'exclusao';
    ComprasDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    ComprasDatasetid.SetParentComponent(ComprasDataset);
    ComprasDatasetid.Name := 'ComprasDatasetid';
    ComprasDatasetid.Tag := 1;
    ComprasDatasetid.FieldName := 'id';
    ComprasDatasetid.Required := True;
    ComprasDatasetcompra_xml_s3.SetParentComponent(ComprasDataset);
    ComprasDatasetcompra_xml_s3.Name := 'ComprasDatasetcompra_xml_s3';
    ComprasDatasetcompra_xml_s3.Tag := 1;
    ComprasDatasetcompra_xml_s3.FieldName := 'compra_xml_s3';
    ComprasDatasetcompra_xml_s3.BlobType := ftMemo;
    ComprasDatasetcompra_xml_s3.Size := 65536;
    ComprasDatasetanexo_sincronizado.SetParentComponent(ComprasDataset);
    ComprasDatasetanexo_sincronizado.Name := 'ComprasDatasetanexo_sincronizado';
    ComprasDatasetanexo_sincronizado.Tag := 1;
    ComprasDatasetanexo_sincronizado.FieldName := 'anexo_sincronizado';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := ComprasDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 136;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 192;
    tmrConsulta.Top := 176;
    XDataWebClient.SetParentComponent(Self);
    XDataWebClient.Name := 'XDataWebClient';
    XDataWebClient.Connection := DMConnection.ApiConnection;
    SetEvent(XDataWebClient, Self, 'OnLoad', 'XDataWebClientLoad');
    SetEvent(XDataWebClient, Self, 'OnError', 'XDataWebClientError');
    XDataWebClient.Left := 472;
    XDataWebClient.Top := 256;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    btnExportarExcel.AfterLoadDFMValues;
    btnPesquisarFornecedor.AfterLoadDFMValues;
    btnPesquisarCompras.AfterLoadDFMValues;
    cbbComprasNfe.AfterLoadDFMValues;
    cbxComprasExcluidas.AfterLoadDFMValues;
    edtFornecedorNome.AfterLoadDFMValues;
    edtDataFinal.AfterLoadDFMValues;
    edtDataInicial.AfterLoadDFMValues;
    edtComprasCfop.AfterLoadDFMValues;
    frmBanco.AfterLoadDFMValues;
    frmBanco.cbbDataBasePesquisa.AfterLoadDFMValues;
    cbbComprasXml.AfterLoadDFMValues;
    ComprasDataset.AfterLoadDFMValues;
    ComprasDatasetcodigo_interno.AfterLoadDFMValues;
    ComprasDatasetfornecedorrazao_social_nome.AfterLoadDFMValues;
    ComprasDatasetemissao.AfterLoadDFMValues;
    ComprasDatasetentrada.AfterLoadDFMValues;
    ComprasDatasetvalor_total.AfterLoadDFMValues;
    ComprasDatasetcfop.AfterLoadDFMValues;
    ComprasDatasetmodelo.AfterLoadDFMValues;
    ComprasDatasetserie.AfterLoadDFMValues;
    ComprasDatasetexcluido.AfterLoadDFMValues;
    ComprasDatasetinclusao.AfterLoadDFMValues;
    ComprasDatasetalteracao.AfterLoadDFMValues;
    ComprasDatasetexclusao.AfterLoadDFMValues;
    ComprasDatasetid.AfterLoadDFMValues;
    ComprasDatasetcompra_xml_s3.AfterLoadDFMValues;
    ComprasDatasetanexo_sincronizado.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
    XDataWebClient.AfterLoadDFMValues;
  end;
end;

end.
